var _BaseModelState_postHandlers, _BaseModelState_preHandlers, _BaseModelState_updatedEvent, _BaseModelState_updatingEvent, _BaseModelState_value, _BaseModelState_onUpdated, _BaseModelState_onUpdating;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import Event from "../Events/Event";
import Guid from '../Guid';
export default class BaseModelState {
    constructor(value) {
        _BaseModelState_postHandlers.set(this, void 0);
        _BaseModelState_preHandlers.set(this, void 0);
        _BaseModelState_updatedEvent.set(this, void 0);
        _BaseModelState_updatingEvent.set(this, void 0);
        _BaseModelState_value.set(this, void 0);
        /** Invokes the subscriptions with the current value */
        _BaseModelState_onUpdated.set(this, () => {
            __classPrivateFieldGet(this, _BaseModelState_updatedEvent, "f").invoke(this, __classPrivateFieldGet(this, _BaseModelState_value, "f"));
        });
        _BaseModelState_onUpdating.set(this, () => {
            __classPrivateFieldGet(this, _BaseModelState_updatingEvent, "f").invoke(this, __classPrivateFieldGet(this, _BaseModelState_value, "f"));
        });
        __classPrivateFieldSet(this, _BaseModelState_value, value, "f");
        __classPrivateFieldSet(this, _BaseModelState_preHandlers, {}, "f");
        __classPrivateFieldSet(this, _BaseModelState_postHandlers, {}, "f");
        __classPrivateFieldSet(this, _BaseModelState_updatedEvent, new Event(), "f");
        __classPrivateFieldSet(this, _BaseModelState_updatingEvent, new Event(), "f");
    }
    /**
     * Creates a subscription to the ModelState that will be called when
     * the state is updated.
     *
     * @param callback The callback to be invoked when the state is updated
     * @returns A symbol that must saved to unsubscribe from the ModelState
     */
    subscribe(postCallback, preCallback) {
        return this.subscribeCore(postCallback, preCallback, true);
    }
    /**
     * Unsubscribes a component from the model state.
     *
     * @param key The symbol that was returned from the subscribe method.
     */
    unsubscribe(key) {
        const postHandler = __classPrivateFieldGet(this, _BaseModelState_postHandlers, "f")[key];
        if (postHandler) {
            __classPrivateFieldGet(this, _BaseModelState_updatedEvent, "f").removeHandler(postHandler);
            delete __classPrivateFieldGet(this, _BaseModelState_postHandlers, "f")[key];
        }
        const preHandler = __classPrivateFieldGet(this, _BaseModelState_preHandlers, "f")[key];
        if (preHandler) {
            __classPrivateFieldGet(this, _BaseModelState_updatingEvent, "f").removeHandler(preHandler);
            delete __classPrivateFieldGet(this, _BaseModelState_preHandlers, "f")[key];
        }
    }
    /** Gets the current value of the ModelState */
    get value() {
        return __classPrivateFieldGet(this, _BaseModelState_value, "f");
    }
    /** Returns the current value of the ModelState */
    valueOf() {
        return __classPrivateFieldGet(this, _BaseModelState_value, "f");
    }
    /** Returns the string version of the ModelState value */
    toString() {
        return `${__classPrivateFieldGet(this, _BaseModelState_value, "f")}`;
    }
    /** Returns the ModelState as a Promise */
    async toPromise() {
        return await new Promise((resolve, reject) => {
            const subscription = this.subscribe((value) => {
                try {
                    resolve(value);
                }
                catch (ex) {
                    reject(ex);
                }
                finally {
                    this.unsubscribe(subscription);
                }
            });
        });
    }
    subscribeCore(postCallback, preCallback, publishCurrentValue = true) {
        const key = Guid.newGuid().toString();
        const postHandler = (s, e) => postCallback(e);
        __classPrivateFieldGet(this, _BaseModelState_postHandlers, "f")[key] = postHandler;
        __classPrivateFieldGet(this, _BaseModelState_updatedEvent, "f").addHandler(postHandler);
        if (preCallback) {
            const preHandler = (s, e) => preCallback(e);
            __classPrivateFieldGet(this, _BaseModelState_preHandlers, "f")[key] = preHandler;
            __classPrivateFieldGet(this, _BaseModelState_updatingEvent, "f").addHandler(preHandler);
        }
        if (publishCurrentValue) {
            postCallback(__classPrivateFieldGet(this, _BaseModelState_value, "f"));
        }
        return key;
    }
    getValue() {
        return __classPrivateFieldGet(this, _BaseModelState_value, "f");
    }
    setValue(value) {
        __classPrivateFieldGet(this, _BaseModelState_onUpdating, "f").call(this);
        __classPrivateFieldSet(this, _BaseModelState_value, value, "f");
        __classPrivateFieldGet(this, _BaseModelState_onUpdated, "f").call(this);
    }
}
_BaseModelState_postHandlers = new WeakMap(), _BaseModelState_preHandlers = new WeakMap(), _BaseModelState_updatedEvent = new WeakMap(), _BaseModelState_updatingEvent = new WeakMap(), _BaseModelState_value = new WeakMap(), _BaseModelState_onUpdated = new WeakMap(), _BaseModelState_onUpdating = new WeakMap();
